import { createStyles, FormControlLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core'

type RadioBoxProps = {
  label?: string
  horizontal?: boolean
  disabled?: boolean
  value: string
  onChange(value: string): void
  options: { value: string; text: string; disabled?: boolean }[]
}

const useStyles = makeStyles((theme) =>
  createStyles({
    largeRadioButton: {
      '& svg': {
        width: '35px',
        height: '35px',
      },
    },
  })
)

export const RadioBox = (props: RadioBoxProps) => {
  const { label, horizontal, disabled, value, onChange, options } = props
  const classes = useStyles()

  const radioGroupProps = {
    row: !!horizontal,
  }

  return (
    <div className="flex flex-col">
      {label && <label className={`pb-2 text-lg font-semibold ${disabled ? 'text-body-lighter' : ''}`}>{label}</label>}
      <RadioGroup
        {...radioGroupProps}
        aria-labelledby="user-status-selection"
        name="user-status-selection"
        value={value}
        onChange={(e: any) => onChange(e.target.value)}
      >
        {options.map((item, index) => (
          <FormControlLabel
            key={`${index}-${item.value}`}
            className="pr-4"
            classes={{ label: 'text-lg' }}
            value={item.value}
            disabled={disabled}
            control={<Radio className={classes.largeRadioButton} color="primary" disabled={item.disabled} />}
            label={item.text}
          />
        ))}
      </RadioGroup>
    </div>
  )
}
